import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';

interface Deps {
  membershipRepository: IMembershipRepository;
}

export function createListProfileIdsByTeamUseCase({ membershipRepository }: Deps) {
  return async function listProfileIdsByTeam(
    orgId: string,
    projectId: string,
    team: string,
  ): Promise<string[]> {
    return membershipRepository.listProfileIdsByTeam(orgId, projectId, team);
  };
}
